import PropTypes from 'prop-types';
import React from 'react';
import CardGrid, { FooterText, formatCount } from './common/grid/CardGrid';
import FitGrid from './common/grid/FitGrid';
import CardRow from './common/grid/CardRow';
import CardGridBody from './common/grid/CardGridBody';
import SiteCard from './SiteCard';
import { diffSiteAgainstPublic, mergeSite } from '../common/ItemTools';
import useGridLayout from '../hooks/useGridLayout';

export default function SiteCardGrid(props) {
  const {
    currentPage,
    siteActions,
    listActions,
  } = props;

  const { handleNextPage, handlePreviousPage } = listActions;

  const {
    pagesCount, pageNumber, sites, siteCount, namespace,
  } = currentPage || {};

  const countLabel = formatCount(siteCount, 'site', 'sites');

  const { arrangement, rowCap } = useGridLayout();
  const lgSpan = Math.max(1, Math.round(12 / arrangement.cols));
  const cardDirection = arrangement.cols === 1 ? 'column' : 'row';

  const merged = (sites || []).map((site) => {
    const card = mergeSite(site);
    if (card) card.shareDiff = diffSiteAgainstPublic(site);
    return card;
  });

  const card = (site) => (
    <SiteCard
      isPreview={namespace === 'public'}
      site={site}
      {...siteActions}
    />
  );

  return (
    <CardGrid
      hasContent={merged.length > 0}
      pageNumber={pageNumber}
      pagesCount={pagesCount}
      onNextPage={handleNextPage}
      onPreviousPage={handlePreviousPage}
      counter={countLabel ? <FooterText>{countLabel}</FooterText> : null}
    >
      <FitGrid>
        {merged.length <= 3 ? (
          <CardRow items={merged} direction={cardDirection} renderCard={card} />
        ) : (
          <CardGridBody items={merged} renderCard={card} lgSpan={lgSpan} rowCap={rowCap} />
        )}
      </FitGrid>
    </CardGrid>
  );
}

SiteCardGrid.propTypes = {
  currentPage: PropTypes.object.isRequired,
  siteActions: PropTypes.object.isRequired,
  listActions: PropTypes.object.isRequired,
};
